import React from "react";
import XIcon from "../../assets/icons/xIcon";

interface PieceFilterElementProps {
    title: string;
    children: any;
    active: boolean;
    setActive: (v: boolean) => void;
    hidden?: boolean;
}

export default function PieceFilterElement(props: PieceFilterElementProps) {
    if(props.hidden) return <></>;
    return <div className={"filter-option" + (props.active ? " active" : "")} onClick={() => {
        if(!props.active) {
            props.setActive(true);
        }
    }}> 
        <div className="close" onClick={() => {
            props.setActive(false);
        }}>
            <XIcon/>
        </div>
        <h3>{props.title}</h3>
        {props.children}
    </div>;
}